import React from 'react';
import { node, string } from 'prop-types';
import classNames from 'classnames';
import css from './ButtonGroup.module.css';

/**
 * Buttons joined into one strip, such as "‹ Today ›" in the calendar. `label` names the group
 * for screen readers (the translated purpose, e.g. "Week").
 */
const ButtonGroup = props => {
  const { rootClassName, className, label, children } = props;
  return (
    <div
      role="group"
      aria-label={label}
      className={classNames(rootClassName || css.root, className)}
    >
      {children}
    </div>
  );
};

ButtonGroup.defaultProps = { rootClassName: null, className: null };

ButtonGroup.propTypes = {
  rootClassName: string,
  className: string,
  label: string.isRequired,
  children: node.isRequired,
};

export default ButtonGroup;
